"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_948_5448)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.083334",
    d: "M10.2303 0H9.76878C9.25898 0 8.8457 0.413274 8.8457 0.923074V3.6923C8.8457 4.2021 9.25898 4.61537 9.76878 4.61537H10.2303C10.7401 4.61537 11.1534 4.2021 11.1534 3.6923V0.923074C11.1534 0.413274 10.7401 0 10.2303 0Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.166667",
    d: "M15.1996 1.455L14.7999 1.22423C14.3584 0.969333 13.7939 1.1206 13.539 1.5621L12.1543 3.96032C11.8994 4.40182 12.0507 4.96636 12.4922 5.22126L12.8919 5.45203C13.3334 5.70693 13.898 5.55566 14.1529 5.11416L15.5375 2.71594C15.7924 2.27445 15.6411 1.7099 15.1996 1.455Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.25",
    d: "M18.7753 5.19911L18.5445 4.79941C18.2896 4.35791 17.7251 4.20664 17.2836 4.46154L14.8854 5.84615C14.4439 6.10105 14.2926 6.66559 14.5475 7.10709L14.7783 7.50679C15.0332 7.94829 15.5977 8.09956 16.0392 7.84466L18.4374 6.46005C18.8789 6.20515 19.0302 5.64061 18.7753 5.19911Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.333334",
    d: "M20 10.2313V9.76975C20 9.25995 19.5867 8.84668 19.0769 8.84668H16.3077C15.7979 8.84668 15.3846 9.25995 15.3846 9.76975V10.2313C15.3846 10.7411 15.7979 11.1544 16.3077 11.1544H19.0769C19.5867 11.1544 20 10.7411 20 10.2313Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.416667",
    d: "M18.545 15.1991L18.7758 14.7994C19.0307 14.3579 18.8794 13.7934 18.4379 13.5385L16.0397 12.1539C15.5982 11.899 15.0336 12.0502 14.7787 12.4917L14.548 12.8914C14.2931 13.3329 14.4443 13.8975 14.8858 14.1524L17.2841 15.537C17.7256 15.7919 18.2901 15.6406 18.545 15.1991Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M14.7999 18.7758L15.1996 18.545C15.6411 18.2901 15.7924 17.7256 15.5375 17.2841L14.1529 14.8859C13.898 14.4444 13.3334 14.2931 12.8919 14.548L12.4922 14.7788C12.0507 15.0337 11.8995 15.5982 12.1544 16.0397L13.539 18.4379C13.7939 18.8794 14.3584 19.0307 14.7999 18.7758Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.583334",
    d: "M9.7692 20H10.2307C10.7405 20 11.1538 19.5867 11.1538 19.0769V16.3077C11.1538 15.7979 10.7405 15.3846 10.2307 15.3846H9.7692C9.2594 15.3846 8.84612 15.7979 8.84612 16.3077V19.0769C8.84612 19.5867 9.2594 20 9.7692 20Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.666667",
    d: "M4.79992 18.5435L5.19962 18.7743C5.64112 19.0292 6.20566 18.8779 6.46056 18.4364L7.84517 16.0382C8.10007 15.5967 7.9488 15.0322 7.5073 14.7773L7.1076 14.5465C6.6661 14.2916 6.10156 14.4429 5.84666 14.8844L4.46205 17.2826C4.20715 17.7241 4.35842 18.2886 4.79992 18.5435Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.75",
    d: "M1.2242 14.7994L1.45497 15.1991C1.70987 15.6406 2.27441 15.7919 2.71591 15.537L5.11413 14.1524C5.55563 13.8975 5.70689 13.3329 5.452 12.8914L5.22123 12.4917C4.96633 12.0502 4.40178 11.899 3.96028 12.1539L1.56207 13.5385C1.12057 13.7934 0.969299 14.3579 1.2242 14.7994Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.833334",
    d: "M0 9.76871L0 10.2302C0 10.74 0.413274 11.1533 0.923074 11.1533H3.6923C4.2021 11.1533 4.61537 10.74 4.61537 10.2302V9.76871C4.61537 9.25891 4.2021 8.84563 3.6923 8.84563H0.923074C0.413274 8.84563 0 9.25891 0 9.76871Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.916667",
    d: "M1.455 4.79943L1.22423 5.19913C0.969333 5.64063 1.1206 6.20517 1.5621 6.46007L3.96032 7.84468C4.40182 8.09958 4.96636 7.94831 5.22126 7.50681L5.45203 7.10711C5.70693 6.66561 5.55566 6.10107 5.11416 5.84617L2.71594 4.46156C2.27444 4.20666 1.7099 4.35793 1.455 4.79943Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.1996 1.22273L4.79989 1.4535C4.35839 1.7084 4.20713 2.27295 4.46202 2.71444L5.84664 5.11266C6.10153 5.55416 6.66608 5.70543 7.10758 5.45053L7.50728 5.21976C7.94878 4.96486 8.10005 4.40032 7.84515 3.95882L6.46054 1.5606C6.20564 1.1191 5.6411 0.967833 5.1996 1.22273Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_948_5448"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "20",
    height: "20",
    fill: fill
  }))));
};

exports["default"] = _default;